/* eslint-disable @angular-eslint/no-output-on-prefix */

import {
  booleanAttribute,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  Input,
  output,
  viewChild,
} from '@angular/core';
import {
  FormControl,
  ReactiveFormsModule,
  ValidationErrors,
} from '@angular/forms';

import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import {
  FloatLabelType,
  MatFormFieldModule,
} from '@angular/material/form-field';
import { MatInput, MatInputModule } from '@angular/material/input';

import { DEFAULT_ERROR_STATE_MATCHER_PROVIDER } from './providers';
import { CanAutoFocusDirective } from './directives';

import { ErrorMessagePipe } from '@shared/pipes';
import { ControlValueAccessorDirective } from '@shared/directives';

@Component({
  selector: 'app-ccs-input',
  imports: [
    MatButtonModule,
    MatIconModule,
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    CanAutoFocusDirective,
    ErrorMessagePipe,
  ],
  templateUrl: './ccs-input.component.html',
  hostDirectives: [ControlValueAccessorDirective],
  providers: [DEFAULT_ERROR_STATE_MATCHER_PROVIDER],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CcsInputComponent<T> {
  @Input({ required: false }) icon: string | null = null;
  @Input({ required: true }) label = '';
  @Input({ required: false }) placeholder = '';
  @Input({ required: false }) maxLength!: number;
  @Input({ required: false }) type = 'text';
  @Input({ required: false }) floatLabel: FloatLabelType = 'always';
  @Input({ required: false }) hint = '';
  @Input({ required: false }) size: 'xs' | 'sm' | 'md' | 'lg' = 'sm';
  @Input({ required: false, transform: booleanAttribute }) autofocus = false;
  @Input({ required: false }) errorMessages: ValidationErrors | null = null;

  private readonly _va = inject(ControlValueAccessorDirective);

  public readonly cdr = inject(ChangeDetectorRef);
  public readonly element = viewChild(MatInput);

  public onFocus = output<FocusEvent>();
  public onBlur = output<FocusEvent>();
  public onKeydown = output<KeyboardEvent>();
  public onKeyup = output<KeyboardEvent>();
  public onInput = output<InputEvent>();
  public onClickIcon = output<MouseEvent>();

  get control(): FormControl<T | null> {
    return this._va.control;
  }

  protected onEventClickIcon(event: MouseEvent): void {
    event.stopPropagation();
    this.onClickIcon.emit(event);
  }
}
